import { gql } from '@apollo/client';

export const CAP_FINDINGS_QUERY = gql`
  query($jobIds: [Int!]) {
    findings(jobIds: $jobIds) {
      id
      nonComplianceReviewMethod
      nonComplianceCategory
      savedAt
      submittedAt
      actions {
        id
        actionReference
        actionTaken
        actionType
        actualCompletionOfActionDate
        attachmentIds
        attachmentsMeta {
          attId
          filePath
          name
          size
          type
        }
        comments {
          id
          actionId
          comment
          createdBy
          updatedBy
          submittedBy
          createdAt
          updatedAt
          submittedAt
          submittedByUser {
            firstName
            lastName
          }
          submittedByUser {
            firstName
            lastName
          }
        }
        description
        dueDate
        facilityContact
        responsiblePerson
        reviewedBy
        reviewedByUser {
          firstName
          lastName
        }
        reviewedDate
        reviewNotes
        rootCause
        savedAt
        submittedAt
        status
        statusDate
        statusNotes
        statusUpdatedBy
        statusUpdatedByUser {
          firstName
          lastName
        }
        resources {
          id
          actionId
          resourceType
          frequency
          basis
          staffType
          staffDayType
          staffDayValue
          numberOfStaffDays
          currencyId
          costs
          details
          numberOfStaff
          averageDayRate
        }
      }
      checklistQuestionId
      checklistQuestionResultId
      detailedFinding
      dueDate
      info {
        category
        checklistQuestionId
        checklistQuestionIdAlias
        checklistQuestionPosition
        criticality
        name
        section
        number
        sectionId
        sectionIdAlias
        sectionPosition
        isWildCardQuestion
      }
      jobId
      legalRequirements
      recommendations
      nonCompliance
      responsiblePerson
      rootCause
      status
      statusDate
      statusNotes
      statusUpdatedBy
      statusUpdatedByUser {
        firstName
        lastName
      }
      evidenceReviewRequired
    }
  }
`;

export const CAP_HISTORIES_QUERY = gql`
  query($findingIds: [Int!]!) {
    capHistories(findingIds: $findingIds) {
      id
      activity
      checklistQuestionId
      findingId
      submittedAt
      submittedByUser {
        id
        firstName
        lastName
      }
    }
  }
`;
